import React from "react";
import LegalLayout, { Section } from "./LegalLayout";

export default function PoliticaCookies() {
  return (
    <LegalLayout
      testId="cookies-page"
      title="Política de Cookies"
      intro="Entenda como utilizamos cookies para melhorar a sua experiência de navegação no site da Inove Tech."
    >
      <Section heading="O que são cookies">
        <p>
          Cookies são pequenos arquivos armazenados no seu dispositivo que ajudam
          o site a funcionar e a lembrar suas preferências de navegação.
        </p>
      </Section>

      <Section heading="Como usamos">
        <p>
          Utilizamos cookies essenciais para o funcionamento do site e para
          registrar sua preferência de consentimento. Não utilizamos cookies
          para rastreamento invasivo.
        </p>
      </Section>

      <Section heading="Gerenciamento">
        <p>
          Você pode aceitar ou rejeitar os cookies através do banner de
          consentimento. Também é possível gerenciar cookies diretamente nas
          configurações do seu navegador.
        </p>
      </Section>
    </LegalLayout>
  );
}
